export function Assert(condition, message) {
    if (!condition) {
        throw new Error(message || "Assertion failed");
    }
}
//# sourceMappingURL=runtime.js.map